import { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'
import { Spinner, Table } from 'react-bootstrap'
import Icon from 'components/ui/icon'

import StatusBadge from 'components/ui/statusBadge'
import { formatCNPJ } from '../../../utilities/cnpj.util'
import { AdminHospital } from '../types'

type HospitalsTableProps = {
  hospitals: AdminHospital[]
  removingHospitalId?: number
  onRemove: (id: number) => void
}

const HospitalsTable: FunctionComponent<HospitalsTableProps> = ({
  hospitals,
  removingHospitalId,
  onRemove,
}) => (
  <div className="table-wrap">
    <Table hover>
      <thead>
        <tr>
          <th>Hospital</th>
          <th>CNPJ</th>
          <th>Status</th>
          <th className="actions-col">
            <span className="visually-hidden">Ações</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {hospitals.map((hospital) => (
          <tr key={hospital.id}>
            <td className="fw-medium">{hospital.name}</td>
            <td className="muted">{formatCNPJ(hospital.cnpj)}</td>
            <td>
              {hospital.enabled ? (
                <StatusBadge tone="success">Ativo</StatusBadge>
              ) : (
                <StatusBadge tone="neutral">Inativo</StatusBadge>
              )}
            </td>
            <td className="actions-col">
              <div className="row-actions">
                <Link to={`/hospitals/${hospital.id}`} className="row-action">
                  <Icon name="edit" size={14} />
                  Editar
                </Link>
                <button
                  type="button"
                  className="row-action is-danger"
                  onClick={() => onRemove(hospital.id)}
                >
                  {removingHospitalId === hospital.id ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <Icon name="trash" size={14} />
                  )}
                  Remover
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
)

export default HospitalsTable
